import { RadioField } from '@modules/formFields/RadioField'
import SelectField from '@modules/formFields/SelectField'
import { TextAreaField } from '@modules/formFields/TextAreaField'
import React, { Component } from 'react'
import Button from 'react-bootstrap/es/Button'
import { Trans, withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Field, Form, reduxForm, SubmissionError } from 'redux-form/dist/redux-form'
import Consultations from '@services/Consultations'

class ReviewForm extends Component {
  reviewsClient = Consultations.reviews

  submit = (values) => {
    const requestBody = {
      anamnesis: values.anamnesis && values.anamnesis.id,
      media: values.media && values.media.id,
      follow: values.follow && values.follow.id,
      derivation: values.derivation && values.derivation.id,
      score: values.score,
      observations: values.observations,
      room_id: this.props.room.id,
    }
    return this.reviewsClient
      .postRoomReview(this.props.room.id, requestBody)
      .then((res) => {
        this.props.onSuccess(res.data)
        this.props.reset()
      })
      .catch((err) => {
        window.alert(JSON.stringify(err.message, null, 2))
        throw new SubmissionError({ ...err.response.data, _error: err.message })
      })
  }

  render() {
    const { handleSubmit, submitting, t } = this.props
    return (
      <Form onSubmit={handleSubmit(this.submit)} className="form-review">
        <Field
          name="anamnesis"
          component={RadioField}
          options={[
            { id: 'Si', name: t('Si') },
            { id: 'No', name: t('No') },
            { id: 'NP', name: t('NP') },
          ]}
          label={t('Consulta resuelta')}
        />
        <Field
          name="media"
          component={RadioField}
          options={[
            { id: 'Si', name: t('Si') },
            { id: 'No', name: t('No') },
            { id: 'NP', name: t('NP') },
          ]}
          label={t('Soporte imagen')}
        />
        <Field
          name="follow"
          component={RadioField}
          options={[
            { id: 'Si', name: t('Si') },
            { id: 'No', name: t('No') },
            { id: 'NP', name: t('NP') },
          ]}
          label={t('Seguimiento activo')}
        />
        <Field
          name="derivation"
          component={RadioField}
          options={[
            { id: 'Si', name: t('Si') },
            { id: 'No', name: t('No') },
            { id: 'NP', name: t('NP') },
          ]}
          label={t('Derivación demasiado rápida')}
        />
        <Field
          name="score"
          simpleValue
          component={SelectField}
          options={[
            { id: '0', name: '0' },
            { id: '1', name: '1' },
            { id: '2', name: '2' },
            { id: '3', name: '3' },
            { id: '4', name: '4' },
            { id: '5', name: '5' },
            { id: '6', name: '6' },
            { id: '7', name: '7' },
            { id: '8', name: '8' },
            { id: '9', name: '9' },
            { id: '10', name: '10' },
          ]}
          label={<Trans>Valoración</Trans>}
          placeholder={t('Valoración')}
        />
        <Field
          name="observations"
          component={TextAreaField}
          label={<Trans>Observaciones</Trans>}
          placeholder={t('Observaciones')}
        />
        <Button id="submit" type="submit" bsStyle="primary" disabled={submitting}>
          <Trans>Guardar</Trans>
        </Button>
      </Form>
    )
  }
}

const mapStateToProps = (state) => ({
  selfId: state.auth.profile.id,
})

const connected = connect(mapStateToProps)(ReviewForm)

const validate = (values, props) => {
  let errors = {}

  if (!values.anamnesis) errors.anamnesis = props.t('Campo requerido')
  if (!values.media) errors.media = props.t('Campo requerido')
  if (!values.follow) errors.follow = props.t('Campo requerido')
  if (!values.derivation) errors.derivation = props.t('Campo requerido')
  if (!values.score) errors.score = props.t('Campo requerido')
  return errors
}

export default compose(withTranslation(), reduxForm({ form: 'review', validate }))(connected)
